"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ukIreland = exports.otherWhite = exports.other = exports.mixed = exports.mainGroup = exports.groupList = exports.europe = exports.ethnicityConfig = exports.asian = exports.africaCaribbean = exports.EthnicityDefinition = void 0;

var _config = require("../config");

var _types = require("../../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var OptionsElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionsElementDefinition;
});

var mainGroup = {
  key: 'mainGroup',
  type: 'radio',
  items: [{
    key: 'ukIreland',
    label: 'United Kingdom and Ireland (White)'
  }, {
    key: 'africaCaribbean',
    label: 'Africa and Caribbean (Black)'
  }, {
    key: 'europe',
    label: 'Europe (White)'
  }, {
    key: 'asian',
    label: 'Asia (Asian)'
  }, {
    key: 'mixed',
    label: 'Mixed ethnicity'
  }, {
    key: 'other',
    label: 'Other'
  }, {
    key: 'otherWhite',
    label: 'Other (White)'
  }, {
    key: "Don't know"
  }, {
    key: 'Declined to answer'
  }],
  ui: {
    classes: 'small'
  },
  validation: [{
    required: true
  }]
};
exports.mainGroup = mainGroup;
var ukIreland = {
  key: 'ukIreland',
  label: 'United Kingdom and Ireland (White)',
  type: 'radio',
  items: [{
    key: 'England'
  }, {
    key: 'Northern Ireland'
  }, {
    key: 'Mixed UK and Ireland (eg Welsh mother, English father)'
  }, {
    key: 'Republic Of Ireland'
  }, {
    key: 'Scotland'
  }, {
    key: 'Wales'
  }],
  ui: {
    classes: 'small'
  },
  validation: [{
    required: true
  }]
};
exports.ukIreland = ukIreland;
var africaCaribbean = {
  key: 'africaCaribbean',
  label: 'Africa and Caribbean (Black)',
  type: 'radio',
  items: [{
    key: 'Caribbean Islands'
  }, {
    key: 'Africa (excluding North Africa)'
  }, {
    key: 'Any other African or African-Caribbean (excluding North Africa)'
  }],
  ui: {
    classes: 'small'
  },
  validation: [{
    required: true
  }]
};
exports.africaCaribbean = africaCaribbean;
var europe = {
  key: 'europe',
  label: 'Europe (White)',
  type: 'radio',
  items: [{
    key: 'Austria, Belgium, France, Germany, Netherlands, Switzerland'
  }, {
    key: 'Scandinavia (Denmark, Iceland, Norway, Sweden, Finland)'
  }, {
    key: 'Italy, Portugal, Spain'
  }, {
    key: 'Turkey'
  }, {
    key: 'Greece'
  }, {
    key: 'Other Balkan States (eg Serbia, Bulgaria)'
  }, {
    key: 'Eastern Europe (eg Czech Republic, Baltics, Western Russia)'
  }, {
    key: 'Other Northern or Central European descent, or a mixture of those'
  }, {
    key: 'Other Southern or Eastern European descent, or a mixture of those'
  }],
  ui: {
    classes: 'small'
  },
  validation: [{
    required: true
  }]
};
exports.europe = europe;
var asian = {
  key: 'asian',
  label: 'Asia (Asian)',
  type: 'radio',
  items: [{
    key: 'India'
  }, {
    key: 'Pakistan'
  }, {
    key: 'Bangladesh'
  }, {
    key: 'Any other South Asian family origins (eg Nepal, Bhutan)'
  }, {
    key: 'Japan, North Korea, South Korea'
  }, {
    key: 'China, Taiwan'
  }, {
    key: 'Thailand, Indonesia, Myanmar (Burma)'
  }, {
    key: 'Malaysia, Vietnam, Philippines, Cambodia, Laos'
  }, {
    key: 'Any other South East Asian'
  }, {
    key: 'Eastern Russia, Kazakhstan, Uzbekistan, Mongolia'
  }, {
    key: 'Other Asian (inc Mixed Asian)'
  }],
  ui: {
    classes: 'small'
  },
  validation: [{
    required: true
  }]
};
exports.asian = asian;
var mixed = {
  key: 'mixed',
  label: 'Mixed ethnicity',
  type: 'radio',
  items: [{
    key: 'Mixed White and Asian'
  }, {
    key: 'Mixed Black and Asian'
  }, {
    key: 'Mixed White and Black'
  }, {
    key: 'Mixed Asian and Other'
  }, {
    key: 'Mixed Black and Other'
  }, {
    key: 'Mixed White and Other'
  }, {
    key: 'Any other mixed origins'
  }],
  ui: {
    classes: 'small'
  },
  validation: [{
    required: true
  }]
};
exports.mixed = mixed;
var other = {
  key: 'other',
  label: 'Other',
  type: 'radio',
  items: [{
    key: 'Any other Non-European'
  }, {
    key: 'Central America, Mestizo'
  }, {
    key: 'Jewish'
  }, {
    key: 'North Africa and Middle East'
  }, {
    key: 'South America'
  }],
  ui: {
    classes: 'small'
  },
  validation: [{
    required: true
  }]
};
exports.other = other;
var otherWhite = {
  key: 'otherWhite',
  label: 'Other (White)',
  type: 'radio',
  items: [{
    key: 'Australia, New Zealand (Northern European descent)'
  }, {
    key: 'Other white (inc Mixed White)'
  }],
  ui: {
    classes: 'small'
  },
  validation: [{
    required: true
  }]
};
exports.otherWhite = otherWhite;
var groupList = [ukIreland, africaCaribbean, europe, asian, mixed, other, otherWhite];
exports.groupList = groupList;

var EthnicityDefinition = _flowRuntime["default"].type("EthnicityDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(FieldElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("ethnicity")))));

exports.EthnicityDefinition = EthnicityDefinition;
var ethnicityConfig = {
  type: 'ethnicity',
  ui: {
    classes: 'small'
  }
};
exports.ethnicityConfig = ethnicityConfig;